<template>
  <div>
    <v-row
      dense
      class="mb-2"
    >
      <v-col
        cols="12"
        sm="4"
      >
        <v-text-field
          v-model="search"
          label="Buscar (organização)"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          clearable
          hide-details
          @keyup.enter="reload(true)"
          @click:clear="onClear"
        />
      </v-col>
      <v-col
        cols="6"
        sm="3"
      >
        <v-select
          v-model="statusFilter"
          :items="statusOptions"
          label="Status"
          outlined
          dense
          clearable
          hide-details
          @change="reload(true)"
        />
      </v-col>
      <v-col
        cols="6"
        sm="3"
      >
        <v-select
          v-model="planoFilter"
          :items="planOptions"
          label="Plano"
          outlined
          dense
          clearable
          hide-details
          @change="reload(true)"
        />
      </v-col>
      <v-col
        cols="12"
        sm="2"
        class="d-flex align-center justify-md-end"
      >
        <v-btn
          color="primary"
          small
          block
          @click="reload(true)"
        >
          <v-icon small>
            mdi-refresh
          </v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="total"
      :options.sync="options"
      :loading="loading"
      :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
      item-key="id"
      dense
    >
      <template #item.status="{ item }">
        <v-chip
          :color="statusColor(item.status)"
          x-small
          dark
        >
          {{ item.status }}
        </v-chip>
      </template>
      <template #item.organizacao_nome="{ item }">
        <a
          href="#"
          class="text-decoration-none"
          @click.prevent="goToOrg(item)"
        >
          {{ item.organizacao_nome || `#${item.id_organizacao}` }}
        </a>
      </template>
      <template #item.plano_codigo="{ item }">
        {{ item.plano_codigo || `#${item.plano_id}` }}
      </template>
      <template #item.cupom_id="{ item }">
        {{ item.cupom_id ? `#${item.cupom_id}` : '—' }}
      </template>
      <template #item.criado_em="{ item }">
        {{ formatDate(item.criado_em) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import moment from 'moment'
  import { $k } from '@/lib/kraken'

  const STATUS_OPTIONS = [
    { text: 'Ativa', value: 'ativa' },
    { text: 'Teste', value: 'teste' },
    { text: 'Inadimplente', value: 'inadimplente' },
    { text: 'Cancelada', value: 'cancelada' },
    { text: 'Expirada', value: 'expirada' },
  ]

  export default {
    name: 'SubscriptionsSection',

    data: () => ({
      search: '',
      statusFilter: null,
      planoFilter: null,
      items: [],
      total: 0,
      options: { page: 1, itemsPerPage: 10 },
      loading: false,
      plans: [],
      headers: [
        { text: 'ID', value: 'id', width: 80 },
        { text: 'Organização', value: 'organizacao_nome' },
        { text: 'Plano', value: 'plano_codigo', width: 140 },
        { text: 'Status', value: 'status', width: 130 },
        { text: 'Cupom', value: 'cupom_id', width: 100 },
        { text: 'Vencimento', value: 'dia_vencimento', width: 110 },
        { text: 'Criada em', value: 'criado_em', width: 130 },
      ],
      statusOptions: STATUS_OPTIONS,
    }),

    computed: {
      planOptions () {
        return this.plans.map(p => ({ text: `${p.nome} (${p.codigo_plano})`, value: p.id }))
      },
    },

    watch: {
      options: {
        deep: true,
        handler () { this.reload() },
      },
    },

    async mounted () {
      try {
        const plans = await $k.manage.clinic_one.plans.get({ limit: 200 })
        this.plans = plans.results || []
      } catch (err) {
        console.error('[plans.get]', err)
      }
      this.reload(true)
    },

    methods: {
      formatDate (v) {
        if (!v) return '—'
        const m = moment(v)
        return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : v
      },
      statusColor (status) {
        switch (status) {
          case 'ativa': return 'success'
          case 'teste': return 'info'
          case 'inadimplente': return 'warning'
          case 'cancelada': return 'grey'
          case 'expirada': return 'error'
          default: return 'grey'
        }
      },
      onClear () {
        this.search = ''
        this.reload(true)
      },
      async reload (resetPage = false) {
        if (resetPage) this.options = { ...this.options, page: 1 }
        this.loading = true
        try {
          const skip = (this.options.page - 1) * this.options.itemsPerPage
          const payload = { skip, limit: this.options.itemsPerPage }
          if (this.search) payload.q = this.search
          if (this.statusFilter) payload.status = this.statusFilter
          if (this.planoFilter) payload.plano_id = this.planoFilter
          const res = await $k.manage.clinic_one.subscriptions.get(payload)
          this.items = res.results || []
          this.total = res.total || 0
        } catch (err) {
          console.error('[subscriptions.get]', err)
        } finally {
          this.loading = false
        }
      },
      goToOrg (item) {
        this.$router.push({
          path: '/clinic-one/organizations',
          query: { org: item.id_organizacao, tab: 'subscriptions' },
        })
      },
    },
  }
</script>
